import Cookies from 'js-cookie';
import { apiFetch } from '../../services/api';

const API_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8001';

const SupervisorService = {

  // Add a new supervisor
  async addSupervisor(supervisorData, files) {

    const payload = {
      ...supervisorData,
      profilePath: files.profilePhoto || undefined,
      licencePath: files.license || undefined,
      authorizedSign: files.authorizedSignature || undefined,
      commercialLicence: files.commercialLicense || undefined,
    };

    try {
      const response = await apiFetch(`${API_URL}/admin/AddSupervisor`, {
        method: 'POST',
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Failed to add supervisor');
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Error adding supervisor: ${error.message}`);
    }
  },
  // Update an existing supervisor
  async updateSupervisor(supervisorId, supervisorData, files) {

    const payload = {
      ...supervisorData,
      profilePath: files.profilePhoto || undefined,
    };

    try {
      const response = await apiFetch(`${API_URL}/admin/updateSupervisor/${supervisorId}`, {
        method: 'PUT',
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Failed to update supervisor');
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Error updating supervisor: ${error.message}`);
    }
  },
  // Delete a supervisor
  async deleteSupervisor(supervisorId, admin_id) {
    const payload = {
      admin_id: admin_id,
    };

    try {
      const response = await apiFetch(`${API_URL}/admin/deleteSupervisor/${supervisorId}`, {
        method: 'DELETE',
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error('Failed to delete supervisor');
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Error deleting supervisor: ${error.message}`);
    }
  },
  async uploadProfilePhoto(file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('module_id', '1');
    formData.append('pathLocation', 'PROFILE_IMAGES/');

    // Debug FormData contents
    console.log('FormData contents for uploadProfilePhoto:');
    for (let [key, value] of formData.entries()) {
      console.log(`${key}: ${value instanceof File ? value.name : value}`);
    }

    try {
      const response = await apiFetch(`${API_URL}/admin/awsS3FileUpload`, {
        method: 'POST',
        body: formData,
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to upload profile photo: ${response.status} ${response.statusText} - ${errorText}`);
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Error uploading profile photo: ${error.message}`);
    }
  },
  async getAllSupervisor() {
    try {
      // Get adminId from cookies
      const adminId = Cookies.get('adminid') || localStorage.getItem('adminid');
      if (!adminId) {
        throw new Error('Admin ID not found in cookies');
      }

      const response = await apiFetch(`${API_URL}/admin/admingetsupervisordetails/${adminId}`, {
        method: 'GET',
      });

      if (!response.ok) {
        const errorText = await response.text();
        throw new Error(`Failed to fetch supervisors: ${response.status} ${response.statusText} - ${errorText}`);
      }

      return await response.json();
    } catch (error) {
      throw new Error(`Error fetching supervisors: ${error.message}`);
    }
  }
};

export default SupervisorService;